import { render, staticRenderFns } from "./consumerTripleRecordLists.vue?vue&type=template&id=3bcde4c2&scoped=true&"
import script from "./consumerTripleRecordLists.vue?vue&type=script&lang=js&"
export * from "./consumerTripleRecordLists.vue?vue&type=script&lang=js&"
import style0 from "./consumerTripleRecordLists.vue?vue&type=style&index=0&id=3bcde4c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcde4c2",
  null
  
)

export default component.exports